import { createFileRoute } from '@tanstack/react-router';
import ReminderManagement from '../../components/manager/ReminderManagement';
import StaffPortal from '../../components/portals/StaffPortal';

export const Route = createFileRoute('/staff/reminders')({
  component: StaffRemindersRoute,
});

function StaffRemindersRoute() {
  return (
    <StaffPortal>
      <ReminderManagement />
    </StaffPortal>
  );
}
